import { Injectable } from '@angular/core';
import { RESTServiceBase } from '../../common/service.base';
import { AppConfig } from '../../configuration/app.config';
import { AuthService } from '../../services/auth.service';

@Injectable()
export class IdentityService extends RESTServiceBase {

  constructor(
    authService: AuthService,
    conf: AppConfig
  ) {
    super(
      'v1',
      'SystemRole',
      authService,
      conf.IMSConfig
    );
  }

  public getRoles(): Promise<string[]> {
    return super.get<string[]>(undefined);
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/identity/identity.service.ts